<template>
  <b-row class="my-10 mwe-tags">
    <b-col sm="12">
      <label class="fs-sa-14" for="page-tags" style="padding-top: 7px">
        <span>{{ $t("engine.managePage.pageAddEdit.seo.lblTag", languageEngine) }}</span>
        <span class="text-hint ml-3">({{ languageUse && languageUse.toUpperCase() }})</span>
        <span class="text-hint ml-3" v-b-tooltip.hover :title='$t("engine.managePage.pageAddEdit.seo.hintTag",languageEngine)'>
          <i class="fas fa-question-circle"></i>
        </span>
      </label>
    </b-col>
    <b-col
      sm="12"
      :class="{ errors: validate.$error || (errorLimit && tagTemp) }"
      class="tags-keywords"
    >
      <b-form-tags
        id="page-tags"
        input-id="keywords-tags"
        :input-attrs="{ 'aria-describedby': 'tags-remove-on-delete-help' }"
        :value="value"
        no-outer-focus
        separator=" "
        :limit="tagMax"
        :placeholder="
          !value || value.length === 0
            ? $t('engine.managePage.pageAddEdit.seo.plcTag', languageEngine)
            : ''
        "
        remove-on-delete
        limitTagsText=""
        disableAddButton
        tag-removed-label
        style="min-height: 64px;"
      >
        <template #default="{ tags, inputAttrs, removeTag }">
          <ul class="b-form-tags-list list-unstyled mb-0 d-flex flex-wrap align-items-center">
            <li
              v-for="(tag, index) in tags"
              :key="tag"
              :title="tag"
              :id="`tag_${index}`"
              :class="{ blink: duplicateIDIndex === index }"
              class="badge b-form-tag d-inline-flex align-items-baseline mw-100 badge-secondary"
            >
              <span class="b-form-tag-content flex-grow-1">
                {{ tag }}
              </span>
              <button
                aria-keyshortcuts="Delete"
                type="button"
                @click_="removeTag(tag)"
                @click="handleTag('delete', index)"
                aria-label="Remove tag"
                class="close b-form-tag-remove"
                :aria-controls="`__BVID__${tag}`"
                :aria-describedby="`__BVID__${tag}__taglabel_`"
              >
                ×
              </button>
            </li>
            <li
              role="none"
              aria-live="off"
              aria-controls="page-keyword___tag_list__"
              class="b-from-tags-field flex-grow-1"
            >
              <div role="group" class="d-flex">
                <b-form-input
                  :id="inputAttrs.id"
                  class="b-form-tags-input w-100 flex-grow-1 p-0 m-0 bg-transparent border-0"
                  style="height: 22px; max-height: 22px; outline: 0px; min-width: 5rem;"
                  v-model.trim="tagTemp"
                  @keydown.enter="handleTag()"
                  @keydown.delete="handleTag('delete')"
                  @update="onTagState"
                  :placeholder="
                    !value || value.length === 0
                      ? $t('engine.managePage.pageAddEdit.seo.plcTag', languageEngine)
                      : ''
                  "
                  @blur="addTag"
               />
              </div>
            </li>
          </ul>
        </template>
      </b-form-tags>
      <small data-validate="maxLength" v-if="(!validate.maxLength && validate.$error) || (errorLimit && tagTemp)">{{ $t('engine.managePage.pageAddEdit.seo.errTagMax', languageEngine) }}</small>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    validate: {
      type: Object,
    },
  },
  data() {
    return {
      tagMax: 20,
      errorLimit: false,
      tagTemp: "",
      duplicateIDIndex: "",
    };
  },
  computed: {
    ...mapGetters({
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
    }),
  },

  methods: {
    onTagState() {
      if (this.value.length >= this.tagMax) {
        this.errorLimit = true;
      } else {
        this.errorLimit = false;
      }
    },
    clearTagTemp() {
      return this.tagTemp = "";
    },
    handleTag(state = "", indexDel = -1) {
      let tagTemp = this.tagTemp.toString().trim();

      if (state === "delete") {
        if (tagTemp == "") {
          this.value.splice(indexDel, 1);
          this.$emit("input", this.value);
        }
      } else {
        if (!tagTemp) return this.clearTagTemp();

        this.errorLimit = false;
        this.duplicateIDIndex = this.value.findIndex((v) => v == tagTemp);

        if (this.duplicateIDIndex >= 0) { // dup (>=0)
          this.clearTagTemp();
        } else { // not dup (-1)
          if (this.value.length >= this.tagMax) {
            this.errorLimit = true;
            this.clearTagTemp();
          } else {
            const newTags = tagTemp.split(/[,]+/); // Split by commas
            newTags.forEach((tag) => {
              if (tag.trim() !== "") {
                this.value.push(tag.trim());
              }
            });
            
            // this.value.push(tagTemp);
            this.$emit("input", this.value);
            this.clearTagTemp();
          }
        }
      }
      setTimeout(() => {
        this.duplicateIDIndex = "";
      }, 2000);
    },
    addTag($e) {
      if(this.value.length < this.tagMax && $e.target.value != '') {
        this.value.push($e.target.value);
      }
      this.tagTemp = '';
    }
  },
};
</script>

<style lang="scss" scoped>
.tags-keywords {
  #page-keyword___tag_list__ > li.b-from-tags-field.flex-grow-1 > div > button {
    display: none;
  }
  .badge-secondary {
    color: #53585d !important;
    background-color: #dee3e6 !important;
  }
  .badge {
    height: 20px !important;
    padding : 0px 8px;
    position: relative;
    bottom: 0px;
    gap : 8px;
    box-shadow : unset;
  }
}
.errors .b-form-tags-input:focus,
.errors input.b-form-tags-input:focus,
.b-form-tags-input,
.b-form-tags-input:focus {
  box-shadow: unset !important;
}
.blink {
  -webkit-animation: 2s linear condemned_blink_effect; /* for Safari 4.0 - 8.0 */
  animation: 2s linear condemned_blink_effect;
}

/* for Safari 4.0 - 8.0 */
@-webkit-keyframes condemned_blink_effect {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

@keyframes condemned_blink_effect {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}
</style>